import request from '@/utils/request'

// 首页轮播 + 底部的文章兰
export function getBanner() {
    return request({
        url: '/api/boss.boss/data',
        method: 'get'
    })
}

// 行业列表
export function getIndustryList() {
    return request({
        url: '/api/boss.talents.type/list',
        method: 'get'
    })
}

// 地区列表
export function areaList() {
    return request({
        url: '/api/boss.talents.city/list',
        method: 'get'
    })
}

// 获取首页人才列表&typeId=&cityId=2
export function talentsList(params) {
    return request({
        url: '/api/boss.talents.talents/home',
        method: 'get',
        params
    })
}

// 人才列表&typeId=&cityId=2&page=1
export function talentsListApi(params) {
    return request({
        url: '/api/boss.talents.talents/list',
        method: 'get',
        params
    })
}

//人才详情 &talentsId
export function talentsDetail(params) {
    return request({
        url: '/api/boss.talents.talents/detail',
        method: 'get',
        params
    })
}

// 新闻列表&categoryId=10001&page=1
export function newsList(params) {
    return request({
        url: '/api/article/list',
        method: 'get',
        params
    })
}

// 新闻详情&articleId=10001
export function newsDetail(params) {
    return request({
        url: '/api/article/detail',
        method: 'get',
        params
    })
}

// 新闻分类列表
export function newsCategoryList() {
    return request({
        url: '/api/article.category/list',
        method: 'get'
    })
}

// 首页商品列表&page=1
export function goodsList(params) {
    return request({
        url: '/api/boss.goods.goods/homeList',
        method: 'get',
        params
    })
}

export function goodsCategoryAll(params) {
    return request({
        url: '/api/boss.goods.category/all',
        method: 'get',
        params
    })
}

// 商品列表&goodsName=&page=1
export function goodsListApi(params) {
    return request({
        url: '/api/boss.goods.goods/list',
        method: 'get',
        params
    })
}

// 商品详情&goodsId=10001
export function goodsDetail(params) {
    return request({
        url: '/api/boss.goods.goods/detail',
        method: 'get',
        params
    })
}
